import { ReactComponent as FeipLogoSvg } from '../../assets/images/feip-logo.svg';

export const FeipLogoIcon: SvgIcon = (props) => {
    return <FeipLogoSvg {...props} />;
};
